<template>
  <rpm-input
      label="CEP"
      placeholder="CEP"
      v-mask="'#####-###'"
      class="col-span-3"
      v-model="address.zipcode"
      :errors="errors.zipcode"
      optional
  ></rpm-input>

  <rpm-input
      label="Estado"
      placeholder="Estado"
      class="col-span-3"
      type="select"
      v-model="address.uf"
      :options="states"
      optionLabel="name"
      optionValue="id"
      :errors="errors.uf"
      :required="required"
      :optional="!required"
  ></rpm-input>

  <rpm-input
      label="Cidade"
      placeholder="Cidade"
      class="col-span-3"
      type="select"
      v-model="address.city_id"
      :options="cities"
      optionLabel="cidade"
      optionValue="id_cidade"
      :errors="errors.city_id"
      required
  ></rpm-input>

  <rpm-input
      label="Bairro"
      placeholder="Bairro"
      class="col-span-3"
      type="select"
      v-model="address.neighborhood_id"
      :options="neighborhoods"
      optionLabel="neighborhood"
      optionValue="neighborhood_id"
      :errors="errors.neighborhood_id"
      required

  ></rpm-input>

  <rpm-input
      label="Logradouro"
      placeholder="Logradouro"
      type="autocomplete"
      @complete="findAddress"
      @item-select="selectedAddress"
      :suggestions="suggestions"
      optionLabel="full_address"
      optionValue="address"
      class="col-span-3"
      v-model="landmark"
      :errors="errors.address"
      @hide="setAddress"
      required
  ></rpm-input>

  <rpm-input
      label="N°"
      placeholder="Número"
      class="col-span-3"
      type="text"
      positive
      v-model="address.number"
      :errors="errors.number"
      optional
  ></rpm-input>

  <rpm-input
      label="Complemento"
      placeholder="Complemento do endereço. Ex.. Apto 2"
      class="col-span-3"
      v-model="address.complement"
      :errors="errors.complement"
      optional
  ></rpm-input>

  <rpm-input
      label="Ponto de referência"
      placeholder="Ponto de referência"
      class="col-span-3"
      v-model="address.reference_point"
      :errors="errors.reference_point"
      optional
  ></rpm-input>
</template>


<script>

import addressRepository from "#repositories/addressRepository";
import {defaultLocation, defaultCity} from '#constants/appInfo'

export default {
  name: "AddressForm",
  props: {
    address: {
      type: Object,
      default: {},
    },
    errors: {
      type: Object,
      default: {},
    },
    block: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    notSetOnStart: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      zipping: false,
      findZipTimer: null,
      findAddressTimer: null,
      searching: false,
      states: [],
      cities: [],
      neighborhoods: [],
      suggestions: [],
      landmark: ''
    }
  },
  methods: {
    setAddress() {
      if (!this.landmark.address) {
        this.address.address = this.landmark
      }
    },
    async findZipcode(zip) {
      return (
          await addressRepository.findZipcode(zip)
      ).data;
    },
    findAddress() {
      addressRepository.findZipcode(this.landmark, 'address').then((response) => {
        this.suggestions = response.data;
      }).catch((error) => {
        this.address.address = this.landmark
        this.suggestions = [];
        this.$notify(error.message, 'error')
      })
    },
    selectedAddress(event) {
      this.address.uf = event.value.state.code;
      this.address.city_id = event.value.city.id;
      this.address.neighborhood_id = event.value.neighborhood.id;
      this.address.address = `${event.value.address_type} ${event.value.address}`;
    },
    async getStates() {
      this.states = (
          await addressRepository.getStates()
      ).data;

      this.address.uf = defaultLocation;
    },
    async getCities(uf) {
      if (!this.zipping && !this.block) this.address.city_id = null;

      if (uf) {
        this.cities = (
            await addressRepository.getCities(uf)
        ).data;
        this.address.city_id = parseInt(defaultCity)
      }
    },
    async getNeighborhoods(city) {
      if (!this.block) {
        if (!this.zipping) {
          this.address.neighborhood_id = null;
        } else this.zipping = false;
      }

      if (city) this.neighborhoods = (
          await addressRepository.getNeighborhoods(city)
      ).data;
    },
  },
  watch: {
    'address.zipcode'(val) {
      if (val && !this.block) {
        if (this.findZipTimer) clearTimeout(this.findZipTimer);

        this.findZipTimer = setTimeout(async () => {
          const zip = await this.findZipcode(val);


          this.zipping = true;

          this.address.uf = zip[0].state.code;
          this.address.city_id = zip[0].city.id;
          this.address.neighborhood_id = zip[0].neighborhood.id;
          this.address.address = zip[0].full_address;
          this.landmark = zip[0].full_address


        }, 1000);
      }
    },
    'address.uf'(val) {
      this.getCities(val);
    },
    'address.city_id'(val) {
      this.getNeighborhoods(val);
    },
    landmark(val){
      if(val.length === 0){
        this.address.address = null
      }
    }
  },
  mounted() {
    this.getStates();
    if(this.cities.length === 0){
      this.getCities(defaultLocation)
    }
  }
};
</script>
